import styled from "styled-components";

export const BarChartBox = styled.div`
  width: 100%;
  height: 100%;

  .echarts-for-react {
    & > div {
      height: 100% !important;
    }
  }
`;
